import { render, staticRenderFns } from "./LavorazioniList.vue?vue&type=template&id=48549b1c"
import script from "./LavorazioniList.vue?vue&type=script&lang=ts"
export * from "./LavorazioniList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48549b1c')) {
      api.createRecord('48549b1c', component.options)
    } else {
      api.reload('48549b1c', component.options)
    }
    module.hot.accept("./LavorazioniList.vue?vue&type=template&id=48549b1c", function () {
      api.rerender('48549b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LavorazioniList.vue"
export default component.exports